<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate="PATIENT_DEVICE.VIEW_DEVICE.DEVICE_DETAILS">
        Device Details
      </h3>
    </div>
  </div>
  <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
    <div class="mb-3">
      <h5 class="card-label mb-2" translate="PATIENT_DEVICE.VIEW_DEVICE.PATIENT_RANGE">
        Patient Range
      </h5>
      <div class="ml-4">
        <mat-formio [form]="form" [submission]="form_data" readOnly="true"></mat-formio>
      </div>
    </div>
    <div>
      <h5 class="card-label mb-2" translate="PATIENT_DEVICE.VIEW_DEVICE.PATIENT_VITALS.TITLE">
        Patient Vitals
      </h5>

      <div class="mat-table-wrapper ml-4">
        <mat-table class="lmat-elevation-z8" [dataSource]="dataSource">
          <!-- Checkbox Column -->

          <ng-container matColumnDef="patient_vital_id">
            <mat-header-cell
              *matHeaderCellDef
              translate="PATIENT_DEVICE.VIEW_DEVICE.PATIENT_VITALS.ID"
              >ID</mat-header-cell
            >
            <mat-cell *matCellDef="let patientVital">{{ patientVital.patient_vital_id }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="capture_date">
            <mat-header-cell
              *matHeaderCellDef
              translate="PATIENT_DEVICE.VIEW_DEVICE.PATIENT_VITALS.CAPTURE_DATE"
              >Capture Date</mat-header-cell
            >
            <mat-cell *matCellDef="let patientVital">{{ patientVital.capture_date }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="alert">
            <mat-header-cell
              *matHeaderCellDef
              translate="PATIENT_DEVICE.VIEW_DEVICE.PATIENT_VITALS.ALERT"
              >Alert</mat-header-cell
            >
            <mat-cell *matCellDef="let patientVital">
              <span
                class="label label-lg label-light-{{
                  getItemCssClassByAlertStatus(patientVital.alert)
                }} label-inline"
                >{{ getAlertString(patientVital.alert) }}</span
              >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="view">
            <mat-header-cell
              *matHeaderCellDef
              translate="PATIENT_DEVICE.VIEW_DEVICE.PATIENT_VITALS.VIEW"
              >View</mat-header-cell
            >
            <mat-cell *matCellDef="let patientVital">
              <button
                color="success"
                matTooltip="View Patient Device"
                (click)="viewVitals(patientVital.patient_vital_value)"
                class="btn btn-icon btn-light btn-hover-success btn-sm"
              >
                <span class="svg-icon svg-icon-md svg-icon-success">
                  <span inlineSVG="./assets/media/svg/icons/General/visible.svg"></span>
                </span>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <!-- Message for empty data  -->
        <div
          class="mat-table-message"
          *ngIf="dataSource.data.length < 1"
          translate="GLOBAL.NO_RECORDS_FOUND"
        >
          No Records Found
        </div>
      </div>

      <!-- start: BOTTOM -->
      <div class="mat-table-bottom ml-4">
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close><span translate="GLOBAL.CLOSE">Close</span></button>
      </div>
    </div>
  </div>
</div>
